import { STATUS_COLORS, BORDER_COLORS } from '../constants/statusMappings';

export const getStatusBadgeColor = (status: string) => {
  return STATUS_COLORS[status as keyof typeof STATUS_COLORS] || 'gray';
};

export const getBorderColor = (status: string) => {
  return BORDER_COLORS[status as keyof typeof BORDER_COLORS] || '#95a5a6';
};